// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the `lazy()` boundary
// (`ConversationAssistantUILazy`) and the intent-time preload both go through here so they share
// one chunk identity.
export const importConversationAssistantUI = (): Promise<
	typeof import('./ConversationAssistantUI')
> =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-ui" */ './ConversationAssistantUI'
	);
